<template>
  <div
    v-show="visible"
    class="theme-dialog--wrap tw-overlay"
    :class="classNames"
    @click.self="handleWrapperClick"
  >
    <transition name="scale">
      <div
        v-show="visible"
        ref="content"
        class="dialog"
        :class="{
          'dialog-box': box,
          'dialog-desktop': pc,
          'has-title': title && box,
          'no-title': !title,
          'dialog--html': !!dangerouslyUseHTMLString,
          'dialog--vnode': !!$slots.default
        }"
        :style="{
          marginTop: `${scrollMarginTop}px`,
          marginBottom: `${scrollMarginTop ? 10 : 0}px`,
          maxWidth: maxWidth
        }"
      >
        <slot name="close-btn">
          <div
            v-if="showClose"
            class="m-close-btn"
            @click="handleAction('close')"
          >
            <!-- eslint-disable -->
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M551.822222 512l318.577778-318.577778c11.377778-11.377778 11.377778-28.444444 0-39.822222s-28.444444-11.377778-39.822222 0L512 472.177778 193.422222 147.911111c-11.377778-11.377778-28.444444-11.377778-39.822222 0s-11.377778 28.444444 0 39.822222L472.177778 512l-318.577778 318.577778c-11.377778 11.377778-11.377778 28.444444 0 39.822222 5.688889 5.688889 11.377778 5.688889 22.755556 5.688889s17.066667 0 22.755555-5.688889L512 551.822222l318.577778 318.577778c5.688889 5.688889 11.377778 5.688889 22.755555 5.688889s17.066667 0 22.755556-5.688889c11.377778-11.377778 11.377778-28.444444 0-39.822222L551.822222 512z"
              ></path>
            </svg>
            <!-- eslint-enable -->
          </div>
        </slot>

        <slot name="dialog-header">
          <div
            v-if="title"
            class="dialog--header"
          >
            <h3 class="dialog-title">
              {{ title }}
            </h3>
          </div>
        </slot>
        <div class="dialog--main">
          <slot>
            <div
              v-if="!dangerouslyUseHTMLString"
              class="dialog--body"
            >
              <p class="dialog-content">
                {{ message }}
              </p>
            </div>
            <!-- eslint-disable -->
            <div
              v-else
              class="dialog--body"
              v-html="message"
            />
            <!-- eslint-enable -->

            <div
              v-if="!box || (pc && moreButtonText.length < 3)"
              class="dialog--footer"
              :class="[
                direction,
                pc ? 'dialog-desktop--footer' : 'dialog--footer',
                {
                  'dialog-single-btn': !cancelButtonText || !confirmButtonText
                }
              ]"
            >
              <a
                v-if="cancelButtonText"
                class="btn btn--cancel"
                @click.self="handleAction('cancel')"
                >{{ cancelButtonText }}</a
              >
              <a
                v-if="confirmButtonText"
                class="btn btn--ok"
                @click.self="handleAction('confirm')"
                >{{ confirmButtonText }}</a
              >
            </div>

            <div
              v-if="moreButtonText.length >= 3"
              :class="[direction, pc ? 'dialog-desktop--footer' : 'dialog--footer']"
            >
              <template v-for="(btn, index) in moreButtonText">
                <a
                  :key="index"
                  class="btn btn--cancel"
                  :class="{ 'btn--other': moreButtonText.length >= 3 }"
                  @click.self="handleAction('confirm' + index)"
                  >{{ btn }}</a
                >
              </template>
            </div>
          </slot>

          <div
            v-if="showFooter"
            class="dialog--footer"
            :class="[
              direction,
              pc ? 'dialog-desktop--footer' : 'dialog--footer',
              {
                'dialog-single-btn': !cancelButtonText || !confirmButtonText
              }
            ]"
          >
            <a
              v-if="cancelButtonText"
              class="btn btn--cancel"
              @click.self="handleAction('cancel')"
              >{{ cancelButtonText }}</a
            >
            <a
              v-if="confirmButtonText"
              class="btn btn--ok"
              @click.self="handleAction('confirm')"
              >{{ confirmButtonText }}</a
            >
          </div>
        </div>
      </div>
    </transition>

    <slot name="content-in-mask" />
  </div>
</template>

<script>
import useScroll from './useScroll'
import './dialog-common.less'

export default {
  name: 'VDialog',
  setup: useScroll,
  data() {
    return {
      box: false, // 是否按照 DialogBox 来显示
      pc: false,
      visible: false,
      title: undefined,
      showClose: true,
      classNames: [],
      message: '',
      action: '',
      // footer 按钮方向，默认水平
      direction: 'horizontal',
      confirmButtonText: '',
      cancelButtonText: '',
      callback: null,
      showFooter: false,
      dangerouslyUseHTMLString: false,
      distinguishCancelAndClose: false,
      // 是否可通过点击遮罩关闭
      closeOnClickModal: false,
      maxWidth: '',
      haveThreeButton: false,
      moreButtonText: [],
      noMargin: false
    }
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.updateScrollStyle()
        return
      }

      this.scrollMarginTop = 0
    }
  },
  methods: {
    doClose() {
      if (!this.visible) return
      this.visible = false
      this.onClose && this.onClose()
      setTimeout(() => {
        if (this.action) this.callback(this.action, this)
      })
    },
    handleWrapperClick() {
      if (!this.closeOnClickModal) return
      this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel')
    },
    handleAction(action) {
      if (this.box) {
        return this.$emit('action', action)
      }

      this.action = action
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(action, this, this.doClose)
      } else {
        this.doClose()
      }
    },
    handleClose() {
      this.handleAction('close')
    }
  }
}
</script>

<style lang="less">
.theme-dialog--wrap {
  z-index: 9999;
  display: flex;
  overflow: auto;
  align-items: center;
  justify-content: center;
}

.dialog {
  position: relative;
  width: (280/375) * 100%;
  max-width: 550px;
  box-sizing: border-box;
  padding-top: 30px;
  border-radius: 12px;
  margin: 0 auto;
  background: #f8f8f8;
  letter-spacing: 0;
  transform-origin: center;
  transition:
    opacity 0.3s,
    transform 0.3s;

  &--body {
    padding-bottom: 30px;
    color: #333;
    font-size: 14px;
    line-height: 18px;

    .dialog-content {
      margin: 0 30px;
      word-break: break-word;
    }
  }

  &.dialog--vnode,
  &.dialog--html,
  &.dialog-box {
    padding: 0;
  }

  &.has-title {
    padding-top: 30px;
  }

  &.no-title:not(.dialog-desktop) {
    .dialog--body {
      font-size: 16px;
      line-height: 20px;
    }
  }

  img {
    max-width: 100%;
  }

  .dialog-title {
    margin: 0 auto 17px;
    color: #333;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
  }

  &--footer {
    padding: 0 30px 20px;

    .btn {
      display: block;
      flex: 1;
      border-radius: 20px;
      color: #000;
      font-size: 14px;
      text-align: center;

      &.btn--ok {
        height: 40px;
        background: #ffca27;
        font-weight: 700;
        line-height: 40px;
        white-space: nowrap;

        &:active:not(.loading) {
          background: #b28d1b;
        }
      }

      &.btn--cancel {
        height: 38px;
        border: 1px solid rgba(255, 202, 39, 100%);
        line-height: 38px;

        &:active {
          border-color: #b28d1b;
          background: #b28d1b;
        }
      }
    }

    &.horizontal {
      display: flex;
      justify-content: center;
      text-align: center;

      .btn--cancel {
        margin-right: 12px;
      }
    }

    &.vertical {
      display: block;
      height: auto;

      .btn {
        margin-bottom: 10px;

        &--cancel {
          margin-bottom: 0;
        }
      }
    }
  }

  .m-close-btn {
    position: absolute;
    z-index: 9;
    top: 0;
    right: 0;
    height: 14px;
    padding: 8px;
    color: #999;
    cursor: pointer;
    text-align: center;

    svg {
      height: 14px;
      fill: currentcolor;
    }
  }
}

.scale-leave-active,
.scale-enter {
  opacity: 0;
  transform: scale3d(0, 0, 0);
}
</style>
